import React from 'react';
import NavButton from '../homepage/header-banner/TopNavButton';
import Footer from '../homepage/footer/Footer';
import { Link, useLocation } from "react-router-dom";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import { ChevronRight } from "@mui/icons-material";
import Image1 from './image/img1.png'
import Image2 from './image/img2.png'
import Image3 from './image/img3.png'
import Image4 from './image/img4.png'
import Image5 from './image/img5.png'
import BgBan from './image/bg-ban.png'
import Elementglobal from './image/Element.png';
import Elementglobal2 from './image/Element-2.png';
import Elementglobal3 from './image/Element-3.png';
import Elementglobal4 from './image/Element-4.png';
import Elementglobal5 from './image/Element-5.png';
import Elementglobal6 from './image/Element-6.png';
import Elementglobal7 from './image/Element-7.png';
import './global-style.css'
import { useEffect } from 'react';

function GlobalPage() {
    useEffect(() => {
        document.title = '해외•베트남';
    }, []);
    return (
        <div className='global-page'>
            <NavButton option={{
                // logo: logoKube,
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061ff' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />

            <div className="header-ban-global">
                <div className="fit-box p-r-l">
                    <div className="header-ban-tt">
                        <div className="header-ban-tt-left">
                            <img src={BgBan} />
                        </div>
                        <div className="header-ban-tt-right">
                            <Link to="#ai-LLM" className="ban-tt-list">
                                <div className="ban-tt-text wh-color">AI 통합 그룹웨어솔루션</div>
                                <div className="ban-tt-icon">
                                    <ChevronRight className="vector-icon wh-color" />
                                </div>
                            </Link>
                            <Link to="#ai-feature2" className="ban-tt-list">
                                <div className="ban-tt-text wh-color">기업전용 클라우드 서버 관리•운영</div>
                                <div className="ban-tt-icon">
                                    <ChevronRight className="vector-icon wh-color" />
                                </div>
                            </Link>
                            <Link to="#ai-feature4" className="ban-tt-list">
                                <div className="ban-tt-text wh-color">기업전용 쿠버네티스 클러스터 인프라 구축•관리</div>
                                <div className="ban-tt-icon">
                                    <ChevronRight className="vector-icon wh-color" />
                                </div>
                            </Link>
                            <Link to="#ai-LLM" className="ban-tt-list">
                                <div className="ban-tt-text wh-color">기업전용 AI (LLM) 개발•관리운영</div>
                                <div className="ban-tt-icon">
                                    <ChevronRight className="vector-icon wh-color" />
                                </div>
                            </Link>
                            <Link to="#ai-LLM" className="ban-tt-list">
                                <div className="ban-tt-text wh-color">클라우드기반 마이크로서비스 API 제공</div>
                                <div className="ban-tt-icon">
                                    <ChevronRight className="vector-icon wh-color" />
                                </div>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>

            <div className='wrap-box global-fea1'>
                <div className='fit-box'>
                    <div className="wrap-title">
                        <div className="txt-32">주요서비스</div>
                    </div>

                    <div className='wrap-content'>
                        <div className='wrap-ct-box'>
                            <div className='wrap-item wrap-ct-text'>
                                <div className='fea-tooltip txt-14'><span>&nbsp;</span>AI call 화면캡쳐 (음성추출/대화화면)</div>
                                <div className='fea-title txt-21'>AI 통합 그룹웨어솔루션</div>
                                <div className='fea-content txt-14'>영어·중국어·베트남어·일본어 음성추출 / 요약 및 번역 <br />
                                    다국적 임직원의 음성통화 관리<br />
                                    실시간 다국어 메세징 교환</div>
                                <div className='fea-btn'>
                                    <button>서비스신청</button>
                                </div>
                            </div>
                            <div className='wrap-item'>
                                <div className='wrap-item-img'>
                                    <img src={Image1} />
                                </div>
                            </div>
                        </div>

                        <div className='wrap-ct-box'>
                            <div className='wrap-item wrap-ct-text'>
                                <div className='fea-tooltip txt-14'><span>&nbsp;</span>BareMetal 서버이미지</div>
                                <div className='fea-title txt-21'>기업전용 클라우드 서버 관리 • 운영</div>
                                <div className='fea-content txt-14'>전용 서비스 모니터프로그램 24시간운영 <br />
                                    전문 서버엔지니어의 관리·운영지원 <br />
                                    8,000 관계사, 5,000 대의 서버운영 노하우보유</div>
                                <div className='fea-btn'>
                                    <button>서비스신청</button>
                                </div>
                            </div>
                            <div className='wrap-item'>
                                <div className='wrap-item-img'>
                                    <img src={Image2} />
                                </div>
                            </div>
                        </div>

                        <div className='wrap-ct-box'>
                            <div className='wrap-item wrap-ct-text'>
                                <div className='fea-tooltip txt-14'><span>&nbsp;</span>Kubernetes 페이지 이미지</div>
                                <div className='fea-title txt-21'>기업전용 쿠버네티스 클러스터 인프라 구축 • 관리</div>
                                <div className='fea-content txt-14'>전용 서비스 모니터프로그램 24시간운영 <br />
                                    전문 서버엔지니어의 관리 · 운영지원  <br />
                                    8,000 관계사, 5,000 대의 서버운영 노하우보유</div>
                                <div className='fea-btn'>
                                    <button>서비스신청</button>
                                </div>
                            </div>
                            <div className='wrap-item'>
                                <div className='wrap-item-img'>
                                    <img src={Image3} />
                                </div>
                            </div>
                        </div>

                        <div className='wrap-ct-box'>
                            <div className='wrap-item wrap-ct-text'>
                                <div className='fea-tooltip txt-14'><span>&nbsp;</span>메일 번역/요약화면</div>
                                <div className='fea-title txt-21'>기업전용 AI (LLM) 인프라 개발 • 관리운영</div>
                                <div className='fea-content txt-14'>전용 서비스 모니터프로그램 24시간운영 <br />
                                    전문 서버엔지니어의 관리 · 운영지원  <br />
                                    8,000 관계사, 5,000 대의 서버운영 노하우보유</div>
                                <div className='fea-btn'>
                                    <button>서비스신청</button>
                                </div>
                            </div>
                            <div className='wrap-item'>
                                <div className='wrap-item-img'>
                                    <img src={Image4} />
                                </div>
                            </div>
                        </div>

                        <div className='wrap-ct-box'>
                            <div className='wrap-item wrap-ct-text'>
                                <div className='fea-tooltip txt-14'><span>&nbsp;</span>Event Sourcing 상단이미지사용</div>
                                <div className='fea-title txt-21'>클라우드기반 마이크로서비스 API 제공</div>
                                <div className='fea-content txt-14'>전용 서비스 모니터프로그램 24시간운영 <br />
                                    전문 서버엔지니어의 관리 · 운영지원  <br />
                                    8,000 관계사, 5,000 대의 서버운영 노하우보유</div>
                                <div className='fea-btn'>
                                    <button>서비스신청</button>
                                </div>
                            </div>
                            <div className='wrap-item'>
                                <div className='wrap-item-img'>
                                    <img src={Image5} />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className='wrap-box'>
                <div className='fit-box boximage-global'>
                    <div className="wrap-title titlebox-global">
                        <div className="txt-32">한비로 베트남 법인 • 연구소</div>
                    </div>
                    <div className="boximage1-global">
                        <div className="listimage-global">
                            <div className="image1-global">
                                <img src="https://hanbiro.com/cloud/library/outsourcing/Company 7.png" />
                            </div>
                            <div className="image1-global">
                                <img src="https://hanbiro.com/cloud/library/outsourcing/Company 4.svg" />
                            </div>
                            <div className="image1-global">
                                <img src="https://hanbiro.com/cloud/library/outsourcing/Company 2.svg" />
                            </div>
                        </div>

                        <div className="listimage2-global">
                            <div className="image1-global">
                                <img src="https://hanbiro.com/cloud/library/outsourcing/Company 8.png" />
                            </div>
                            <div className="image1-global">
                                <img src="https://hanbiro.com/cloud/library/outsourcing/Company 3.svg" />
                            </div>
                            <div className="image1-global">
                                <img src="https://hanbiro.com/cloud/library/outsourcing/Company 6.svg" />
                            </div>
                            <div className="image1-global">
                                <img src="https://hanbiro.com/cloud/library/outsourcing/Company 4.svg" />
                            </div>
                        </div>
                    </div>
                    <div className="boxcard-global">
                        <div className="card-content-global">
                            <div className="card-title-global">
                                <div className="txt-21-global">
                                    MICROSERVICE 개발팀
                                </div>
                                <div className="txt-14-global">
                                    10 Members
                                </div>
                            </div>

                        </div>

                        <div className="card-content-global">
                            <div className="card-title-global">
                                <div className="txt-21-global">
                                    MOBILE 개발팀
                                </div>
                                <div className="txt-14-global">
                                    10 Members
                                </div>
                            </div>

                        </div>

                        <div className="card-content-global">
                            <div className="card-title-global">
                                <div className="txt-21-global">
                                    기업소프트웨어 개발팀
                                </div>
                                <div className="txt-14-global">
                                    10 Members
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="boxcard-global box2-global">
                        <div className="card-content-global">
                            <div className="card-title-global">
                                <div className="txt-21-global">
                                    그룹웨어 개발팀
                                </div>
                                <div className="txt-14-global">
                                    10 Members
                                </div>
                            </div>

                        </div>

                        <div className="card-content-global">
                            <div className="card-title-global">
                                <div className="txt-21-global">
                                    클라우드서비스 운영팀
                                </div>
                                <div className="txt-14-global">
                                    10 Members
                                </div>
                            </div>

                        </div>

                        <div className="card-content-global">
                            <div className="card-title-global">
                                <div className="txt-21-global">
                                    PL / QC 관리팀
                                </div>
                                <div className="txt-14-global">
                                    10 Members
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>

            <div className='wrap-box global-fea4'>
                <div className='fit-box'>
                    <div className="wrap-title">
                        <div className="txt-32">글로벌 한비로</div>
                    </div>

                    <div className='wrap-content'>
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link txt-21 active" id="pills-address1-tab" data-bs-toggle="pill" data-bs-target="#pills-address1" type="button" role="tab" aria-controls="pills-address1" aria-selected="true">한국</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link txt-21" id="pills-address2-tab" data-bs-toggle="pill" data-bs-target="#pills-address2" type="button" role="tab" aria-controls="pills-address2" aria-selected="false">베트남</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link txt-21" id="pills-address3-tab" data-bs-toggle="pill" data-bs-target="#pills-address3" type="button" role="tab" aria-controls="pills-address3" aria-selected="false">미국</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link txt-21" id="pills-address4-tab" data-bs-toggle="pill" data-bs-target="#pills-address4" type="button" role="tab" aria-controls="pills-address4" aria-selected="false">중국</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link txt-21" id="pills-address5-tab" data-bs-toggle="pill" data-bs-target="#pills-address5" type="button" role="tab" aria-controls="pills-address5" aria-selected="false">일본</button>
                            </li>
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="pills-address1" role="tabpanel" aria-labelledby="pills-address1-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5399.646939480377!2d106.74465011183023!3d10.76585688933794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752be5c623d6fb%3A0x32e0a76c33f3bb5f!2sKOTITI%20Viet%20Nam%20Ltd!5e1!3m2!1svi!2s!4v1744165958329!5m2!1svi!2s"
                                                allowfullscreen=""
                                                loading="lazy"
                                                referrerpolicy="no-referrer-when-downgrade"
                                                className='map-box-frame'>
                                            </iframe>
                                        </div>
                                        <div className='map-text-box'>
                                            <div className='txt-21 mb-2'>사무실</div>
                                            <div className='txt-14'>서울시 서초구 남부순환로333길 9 4,5층(효천빌딩) (주)한비로</div>
                                            <div className='txt-14'>대표 전화 : 1544-4755</div>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5399.646939480377!2d106.74465011183023!3d10.76585688933794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752be5c623d6fb%3A0x32e0a76c33f3bb5f!2sKOTITI%20Viet%20Nam%20Ltd!5e1!3m2!1svi!2s!4v1744165958329!5m2!1svi!2s"
                                                allowfullscreen=""
                                                loading="lazy"
                                                referrerpolicy="no-referrer-when-downgrade"
                                                className='map-box-frame'>
                                            </iframe>
                                        </div>
                                        <div className='map-text-box'>
                                            <div className='txt-21 mb-2'>IDC</div>
                                            <div className='txt-14'>서울시 서초구 남부순환로333길 9 4,5층(효천빌딩) (주)한비로</div>
                                            <div className='txt-14'>대표 전화 : 1544-4755</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-address2" role="tabpanel" aria-labelledby="pills-address2-tab">...</div>
                            <div class="tab-pane fade" id="pills-address3" role="tabpanel" aria-labelledby="pills-address3-tab">...</div>
                            <div class="tab-pane fade" id="pills-address4" role="tabpanel" aria-labelledby="pills-address4-tab">...</div>
                            <div class="tab-pane fade" id="pills-address5" role="tabpanel" aria-labelledby="pills-address5-tab">...</div>
                        </div>
                    </div>
                </div>
            </div>




            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color",
                aboutHref: "https://global3.hanbiro.com/qacloud/#/globalpage",
            }} />
        </div>
    )
}

export default GlobalPage;